import { capitalise } from '@kizi/shared-components';
import React from 'react';
import { DetailsTabProps } from '.';
import { ListComp } from '../../../../Product/ExpandedPart/List';

interface Cost {
  label: string;
  value: string;
  tooltip?: string;
}

export const CostsTabSavings: React.FC<DetailsTabProps> = ({ data }) => {
  const order =
    data?.policyPolicyDetails?.[0]?.moneyViewSavings?.[0]?.type === 'V_DOV'
      ? [
          'Minimum saldo rentevergoeding',
          'Maximum saldo rente',
          'Minimum eerste inleg',
          'Maximale saldo rekening',
          'Bonusrente',
        ]
      : [
          'Min. inleg jaarrente',
          'Min. inleg maandrente',
          'Vervroegd opnemen',
          // "Maximum boete",
          'Automatisch sparen',
          'Tijdstip rentebetaling',
        ];

  const convertValue = (value) => {
    if (Number(value) === 1) return 'Ja';
    if (Number(value) === 0 || value === 'neen') return 'Nee';
    if (Number(value) === 999999999) return 'Onbeperkt';
    if (Number(value) > 1) {
      const formatter = new Intl.NumberFormat('de-DE');
      return `€${formatter.format(Number(value))}`;
    }
    return capitalise(value);
  };

  const getTooltip = (label: string): string | undefined => {
    const tooltips: { [key: string]: string } = {
      'Bonusrente':
        'Bonusrente is extra rente die wordt toegevoegd bovenop de standaardrente.',
      'Maximum saldo rente':
        'Het maximale bedrag waar rente op verkregen mag worden.',
      'Maximale saldo rekening':
        'Het maximale bedrag dat op de rekening mag staan.',
    };
    return tooltips[label];
  };

  const costs: Cost[] = order.reduce((acc: Cost[], label: string) => {
    const fee = data?.fees?.find((item) => item.label === label);
    if (fee) {
      acc.push({
        label: fee.label.replace('Min.', 'Minimale'),
        value: String(convertValue(fee.value)),
        tooltip: getTooltip(fee.label),
      });
    }
    return acc;
  }, []);

  return (
    <ListComp
      groups={[
        {
          rightFieldStyle: {
            textAlign: 'left',
          },
          list: costs,
          title: '',
        },
      ]}
    />
  );
};
